import AbrdnButton from 'components/Generic/Buttons/AbrdnButton';
import AbrdnSelect from 'components/Generic/Forms/FormFields/AbrdnSelect';
import React, { FC } from 'react';
import styles from './DesktopTableRow.module.scss';
import classNames from 'classnames';
import { useTableRow } from '../shared/useTableRow';
import { RowComponentProps } from '../shared/types';
import { useI18n } from 'next-localization';

const DesktopTableRow: FC<RowComponentProps> = ({
  row,
  selectedShareClass,
  onShareClassChange,
  onTogglePastPerformance,
  onTogglePredictivePerformance,
}) => {
  const { placeholder, shareClassOptions, showDownloadButton, downloadlink } = useTableRow(
    row,
    selectedShareClass
  );
  const { t } = useI18n();
  return (
    <tr className={styles.tableRow}>
      <td>{row.name}</td>
      <td>
        <AbrdnSelect
          options={shareClassOptions}
          placeholder={placeholder}
          defaultValue={shareClassOptions[selectedShareClass]}
          className="w-100"
          onChange={(event) => onShareClassChange(row, event.value)}
          disabled={shareClassOptions.length === 0}
        />
      </td>
      <td>
        {row.shareclasses.length > 0 && (
          <button
            type="button"
            className={classNames('btn-naked bi-box-arrow-up-right', styles.btnBoxArrow)}
            onClick={() => onTogglePastPerformance(row)}
          />
        )}
      </td>
      <td>
        {row.shareclasses.length > 0 && (
          <button
            type="button"
            className={classNames('btn-naked bi-box-arrow-up-right', styles.btnBoxArrow)}
            onClick={() => onTogglePredictivePerformance(row)}
          />
        )}
      </td>
      <td>
        {showDownloadButton && (
          <AbrdnButton buttonType="primary" linkField={downloadlink} showExternalIcon={false}>
            <span>{t('download')}</span>
            <em className="bi-download ms-1" aria-hidden="true" />
          </AbrdnButton>
        )}
      </td>
    </tr>
  );
};

export default DesktopTableRow;
